import { css, CSSResult } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { csColorBackground, csColorBorder, csColorFunctional, csColorText } from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { csBorder } from '@cloudsuite/mosaic-shared/styles/globals.style.js'
import { csShadow } from '@cloudsuite/mosaic-shared/styles/shadows.style.js'

export const CSCComparePopup = {
  backgroundColorPopUpOpen: css`var(--csc-compare-popup-background-color, ${csColorBackground.primary})`,
  backgroundColorPopUpClose: css`var(--csc-compare-popup-background-color, ${csColorBackground.inverted})`,
  borderRadius: css`var(--csc-compare-popup-border-radius, ${csBorder.radiusMinimal})`,
}

export const style: CSSResult = css`
  .csc-compare-popup {
    --x-translate: 0px;
    background-color: ${csColorBackground.primary};
    border-radius: ${CSCComparePopup.borderRadius};
    overflow: hidden;
    width: 100%;
    max-width: 395px;
    position: fixed;
    bottom: 0;
    z-index: var(--csc-compare-popup-z-index, 100000);
    animation: popup-enter 300ms ease forwards;
  }

  .csc-compare-popup.position-left {
    left: ${csSpacing.spacing10};
  }

  .csc-compare-popup.position-center {
    --x-translate: -${csSpacing.spacing10};
    left: 50%;
  }

  .csc-compare-popup.position-right {
    right: 50px;
  }

  .csc-compare-popup.is-dismissing {
    animation: popup-exit 300ms ease forwards;
  }

  @keyframes popup-exit {
    from {
      transform: translateX(var(--x-translate)) translateY(0);
      opacity: 1;
    }
    to {
      transform: translateX(var(--x-translate)) translateY(32px);
      opacity: 0;
    }
  }

  @keyframes popup-enter {
    from {
      transform: translateX(var(--x-translate)) translateY(32px);
      opacity: 0;
    }
    to {
      transform: translateX(var(--x-translate)) translateY(0);
      opacity: 1;
    }
  }

  .csc-compare-popup.is-open {
    box-shadow: ${csShadow.default};
  }

  .csc-compare-popup.is-open .header {
    background-color: ${CSCComparePopup.backgroundColorPopUpOpen};
  }

  .csc-compare-popup.is-open .header-left cse-icon {
    top: ${csSpacing.spacing00};
    position: relative;
  }
  
  .header {
    background-color: ${CSCComparePopup.backgroundColorPopUpClose};
    align-items: center;
    display: flex;
    justify-content: space-between;
    padding: ${csSpacing.spacing06};
    --cse-text-color: ${csColorText.white};
    --cse-icon-color: ${csColorText.white};
  }
  
  .csc-compare-popup.is-open .header {
    --cse-text-color: ${csColorText.headings};
    --cse-icon-color: ${csColorText.body};
  }

  .header-left {
    align-items: center;
    display: flex;
    gap: ${csSpacing.spacing04};
    cursor: pointer;
  }

  .header-left cse-icon {
    margin-right: ${csSpacing.spacing04};
  }

  cse-badge {
    --cse-badge-floating-border-width: 0;
  }

  csc-product-preview {
    --cse-image-border-radius: ${csSpacing.spacing01};
  }

  .collapsible {
    display: grid;
    grid-template-rows: 0fr;
    transition: grid-template-rows 300ms ease;
  }

  .collapsible.is-open {
    grid-template-rows: 1fr;
  }

  .collapsible-inner {
    overflow: hidden;
  }

  .items {
    display: flex;
    flex-direction: column;
    padding-inline: ${csSpacing.spacing05};
    row-gap: ${csSpacing.spacing06};
  }

  @keyframes item-enter {
    from {
      opacity: 0;
      max-height: 0;
    }
    to {
      opacity: 1;
      max-height: 200px;
    }
  }

  .item {
    animation: item-enter 300ms ease forwards;
    align-items: center;
    border-bottom: ${csSpacing.spacing00} solid ${csColorBorder.light};
    display: grid;
    gap: ${csSpacing.spacing06};
    grid-template-columns: 1fr auto;
    padding-bottom: ${csSpacing.spacing06};
  }

  .item-removing {
    animation: item-exit 300ms ease forwards;
    overflow: hidden;
  }

  @keyframes item-exit {
    from {
      opacity: 1;
      max-height: 200px;
    }
    to {
      opacity: 0;
      max-height: 0;
      padding-bottom: 0;
    }
  }

  .max-error {
    display: flex;
    justify-content: center;
    --cse-text-color: ${csColorFunctional.error};
    --cse-text-gap: ${csSpacing.spacing04};
  }

  .footer {
    padding: ${csSpacing.spacing05};
  }
`
